import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Row,
  Col,
  Modal,
  Button,
  Input,
  Select,
  FormItem,
  Popconfirm,
  SuccessNotification,
  message,
} from "components/common";
import { countryStates, statesByCountry } from "common/country";
import { callPostApiWithAuth } from "utils/api";
import { Wrapper } from "./AddModal.styled";

export default function AddModal(props) {
  const dispatch = useDispatch();
  const myUser = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    bk_name: "",
    bk_bank: "",
    bk_account: "",
    bk_routing: "",
    billing_address: "",
    billing_address_line2: "",
    billing_city: "",
    billing_zipcode: "",
    billing_state: "",
    billing_country: "",
  });
  const [isUpdating, setIsUpdating] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  const onSubmitDone = (res) => {
    setIsUpdating(false);
    SuccessNotification(res.message);
    dispatch({ type: "auth.RELOAD" });
    props.setModalMode(undefined);
  };
  const onSubmitFail = () => {
    setIsUpdating(false);
  };
  const handleSubmit = () => {
    // Validation
    const regex =
      /^[\u4e00-\u9fa5_A-Za-z0-9\s!@#$%^&*()_+=\-`~\\\]\[{}|';:/.,?><]*$/;

    let errorMessages0 = [];
    if (!formData.bk_name) {
      errorMessages0.push({
        field: "bk_name",
        message: "Required",
      });
    } else if (regex.exec(formData.bk_name) == null) {
      errorMessages0.push({
        field: "bk_name",
        message: "Please input only English",
      });
    }
    if (!formData.bk_bank) {
      errorMessages0.push({
        field: "bk_bank",
        message: "Required",
      });
    } else if (regex.exec(formData.bk_bank) == null) {
      errorMessages0.push({
        field: "bk_bank",
        message: "Please input only English",
      });
    }
    if (!formData.bk_account) {
      errorMessages0.push({
        field: "bk_account",
        message: "Required",
      });
    }
    if (!formData.bk_routing) {
      errorMessages0.push({
        field: "bk_routing",
        message: "Required",
      });
    }
    if (!formData.billing_address) {
      errorMessages0.push({
        field: "billing_address",
        message: "Required",
      });
    } else if (regex.exec(formData.billing_address) == null) {
      errorMessages0.push({
        field: "billing_address",
        message: "Please input only English",
      });
    }
    if (!formData.billing_city) {
      errorMessages0.push({
        field: "billing_city",
        message: "Required",
      });
    } else if (regex.exec(formData.billing_city) == null) {
      errorMessages0.push({
        field: "billing_city",
        message: "Please input only English",
      });
    }
    if (!formData.billing_zipcode) {
      errorMessages0.push({
        field: "billing_zipcode",
        message: "Required",
      });
    }
    if (!formData.billing_country) {
      errorMessages0.push({
        field: "billing_country",
        message: "Required",
      });
    }
    if (
      !formData.billing_state &&
      statesByCountry(formData.billing_country).length > 0
    ) {
      errorMessages0.push({
        field: "billing_state",
        message: "Required",
      });
    }
    if (
      formData.billing_address_line2 &&
      regex.exec(formData.billing_address_line2) == null
    ) {
      errorMessages0.push({
        field: "billing_address_line2",
        message: "Please input only English",
      });
    }

    setErrorMessages(errorMessages0);

    if (errorMessages0.length > 0) {
      return;
    }

    setIsUpdating(true);
    callPostApiWithAuth(
      `my_account/setting/bank_billing_detail`,
      formData,
      onSubmitDone,
      onSubmitFail
    );
  };

  useEffect(() => {
    setFormData({
      ...formData,
      billing_country: myUser.country,
    });
  }, [myUser]);

  return (
    <Modal width={600} onCancel={() => props.setModalMode(undefined)}>
      <Wrapper>
        <div className="modal-new-title">Add Checking</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "bk_name"
                )}
              >
                <Input
                  label={"Name on Bank*"}
                  value={formData.bk_name}
                  onChange={(e) =>
                    setFormData({ ...formData, bk_name: e.target.value })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "bk_bank"
                )}
              >
                <Input
                  label={"Bank Name*"}
                  value={formData.bk_bank}
                  onChange={(e) =>
                    setFormData({ ...formData, bk_bank: e.target.value })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "bk_account"
                )}
              >
                <Input
                  label={"Account Number*"}
                  value={formData.bk_account}
                  onChange={(e) =>
                    setFormData({ ...formData, bk_account: e.target.value })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "bk_routing"
                )}
              >
                <Input
                  label={"Routing Number*"}
                  value={formData.bk_routing}
                  onChange={(e) =>
                    setFormData({ ...formData, bk_routing: e.target.value })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "billing_address"
                )}
              >
                <Input
                  label={"Address Line 1*"}
                  value={formData.billing_address}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      billing_address: e.target.value,
                    })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "billing_address_line2"
                )}
              >
                <Input
                  label={"Address Line 2"}
                  value={formData.billing_address_line2}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      billing_address_line2: e.target.value,
                    })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "billing_city"
                )}
              >
                <Input
                  label={"City*"}
                  value={formData.billing_city}
                  onChange={(e) =>
                    setFormData({ ...formData, billing_city: e.target.value })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "billing_zipcode"
                )}
              >
                <Input
                  label={"Zip/Postal code*"}
                  value={formData.billing_zipcode}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      billing_zipcode: e.target.value,
                    })
                  }
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            <div className="input-container">
              <FormItem
                errorMessages={errorMessages.filter(
                  (el) => el.field === "billing_country"
                )}
              >
                <Select
                  value={formData.billing_country}
                  label={"Country*"}
                  options={[
                    {
                      label: "Select Country",
                      value: "",
                    },
                    ...countryStates.map((el) => ({
                      label: el.name,
                      value: el.code2,
                    })),
                  ]}
                  style={{ width: "100%" }}
                  onChange={(v) =>
                    setFormData({ ...formData, billing_country: v })
                  }
                  showSearch
                />
              </FormItem>
            </div>
          </Col>{" "}
          <Col xs={24} sm={12}>
            {statesByCountry(formData.billing_country).length > 0 ? (
              <div className="input-container">
                <FormItem
                  errorMessages={errorMessages.filter(
                    (el) => el.field === "billing_state"
                  )}
                >
                  <Select
                    value={formData.billing_state}
                    label={"State/Province*"}
                    options={[
                      {
                        label: "Select State",
                        value: "",
                      },
                      ...statesByCountry(formData.billing_country).map(
                        (el) => ({
                          label: el.name,
                          value: el.name,
                        })
                      ),
                    ]}
                    style={{ width: "100%" }}
                    onChange={(v) =>
                      setFormData({ ...formData, billing_state: v })
                    }
                    showSearch
                  />
                </FormItem>
              </div>
            ) : (
              ""
            )}
          </Col>{" "}
          <Col span={24}>
            <div className="action-btn">
              <Button
                className="cancel-btn"
                onClick={() => props.setModalMode(undefined)}
              >
                Cancel
              </Button>
              <Popconfirm onConfirm={handleSubmit}>
                <Button loading={isUpdating} className="create-btn">
                  Create
                </Button>
              </Popconfirm>
            </div>
          </Col>
        </Row>
      </Wrapper>
    </Modal>
  );
}
